export default __webpack_public_path__ + "static/media/img-13.e9e5b7e0.png";